import MainRouter from "./MainRouter";
import { hot } from "react-hot-loader";
import "./App.css";

function App() {
  return <MainRouter />;
}

export default hot(module)(App);
